<template>
  <gradient-background>
    <center-card>
      <template v-slot:card-title>
        {{$t('registerFromInvite.title', {appName: $t('appName')})}}
      </template>
      <template v-slot:card-body>
        <register-from-invite-form/>
      </template>
    </center-card>
  </gradient-background>
</template>

<script>
  import GradientBackground from '../layouts/general/GradientBackground.vue';
  import CenterCard from '../layouts/cards/CenterCard.vue';
  import RegisterFromInviteForm from '../components/auth/RegisterFromInviteForm.vue';

  export default {
    components: {
      GradientBackground,
      CenterCard,
      RegisterFromInviteForm,
    },
  };
</script>

<style scoped>

</style>
